<template>
  <v-popover
    class="d-inline"
    popover-class="v-popover--dropdown"
  >
    <slot />
    <VsMenu
      slot="popover"
      :buttons="actionGeneratorMixin_actions"
    >
      <slot name="menu" />
    </VsMenu>
  </v-popover>
</template>

<script>
import actionGeneratorMixin from '@/scripts/Components/mixins/actionGeneratorMixin';
import VsMenu from './VsMenu';

export default {
  components: {
    VsMenu,
  },
  mixins: [
    actionGeneratorMixin,
  ],
  props: {
    actions: {
      type: Array,
      default: () => [],
    },
    // We allow arbitary type to be used here
    // eslint-disable-next-line vue/require-prop-types
    props: {
      default: undefined,
    },
  },
};
</script>

<style lang="scss">
.v-popover--dropdown.tooltip.popover {
  .popover-inner {
    padding: 0;
    max-width: initial;

    .vs-menu {
      .vs-button {
        text-align: left;
      }
    }
  }
}
</style>
